<template>
    <div class="sliderRangeVideo">
        <input
            id="myRange"
            type="range"
            class="sliderRangeVideo__input"
            :min="settings.min"
            :max="settings.max"
            :value="settings.value"
            :step="settings.step"
            :style="stylesSlider"
            @input="handleChangeProgress"
            @mousedown="handleFocus(true)"
            @mouseup="handleFocus(false)"
        />
    </div>
</template>

<script>
export default {
    emits: ['handleChangeProgress', 'handleFocus'],
    
    props: {
        settings: { type: Object, requaired: true },
    },

    computed: {
        stylesSlider() {
            return {
                backgroundSize: `${this.settings.value}% 100%`,
            };
        },
    },

    methods: {
        handleChangeProgress(e) {
            this.$emit('handleChangeProgress', e);
        },

        handleFocus(status) {
            this.$emit('handleFocus', status);
        },
    },
};
</script>
